export const config = {
    // serverUrl: 'http://localhost:3335',
    // serverUrl: 'https://apiv1.field-data-lake.com',
    // serverUrl: "https://stgapiv1.field-data-lake.com",
    serverUrl: 'https://stgapiv1.oriente.field-data-lake.com',

    // analyzer: 'http://127.0.0.1:5000',
    analyzer: 'https://ali-analyzer.field-data-lake.com',
};